import { API_ENDPOINT } from "../constants";
import { HTTP } from "./http";

export const SupportService = {

    openTicket: (data: any) => {
        return HTTP.post<any, any>(`${API_ENDPOINT.CORE}users/help-directory/open-ticket`, data);
    },
    getAll: () => {
        return HTTP.get<any, any>(`${API_ENDPOINT.CORE}users/help-directory/get-all`);
    },
    addLink: (data: any) => {
        return HTTP.post<any, any>(`${API_ENDPOINT.CORE}users/help-directory/add`, data);
    },
    editLink: (data:any) => {
        return HTTP.put<any, any>(`${API_ENDPOINT.CORE}users/help-directory/update`, data);
    },
    enableLink: (data: {
        id_help: number,
        status: boolean
    }) => {
        return HTTP.put<any, any>(`${API_ENDPOINT.CORE}users/help-directory/active-help`, data);
    },
    disableLink: (data: {
        id_help: number,
        status: boolean
    }) => {
        return HTTP.put<any, any>(`${API_ENDPOINT.CORE}users/help-directory/disable-help`, data);
    }

}